<template>
    <div>
        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                </div>
                <div class="container shape-container d-flex pb-5">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">Um espaço na Internet
                                    <span>para preservar a memória da dublagem brasileira</span>
                                </h1>
                                <p class="lead  text-white">Comecei a organizar meu acervo no ano da conquista do tetra. O resto da história você pode conferir a seguir, ou acessar os links abaixo:</p>
                                <div class="btn-wrapper">
                                    <base-button
                                            @click="$router.push('/filmes')"
                                            class="mb-3 mb-sm-0"
                                            type="info"
                                            icon="fa fa-film">
                                        Visualizar Acervo
                                    </base-button>
                                    <base-button
                                            @click="$router.push('/filmes-que-procuro')"    
                                            class="mb-3 mb-sm-0"
                                            type="white"
                                            icon="fa fa-search">
                                        Filmes que Procuro
                                    </base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container shape-container d-flex">
                    <!-- Timeline -->
                    <ul class="timeline">
                        <li class="timeline-item bg-white rounded ml-3 p-4 shadow">
                            <div class="timeline-arrow"></div>
                            <h2 class="h5 mb-0">Início da minha coleção</h2><span class="small text-gray"><i class="fa fa-clock-o mr-1"></i>ano de 1994</span>
                            <p class="text-small mt-2 font-weight-light">Foi no ano do tetra que comecei a reunir os VHS e converter os filmes dublados que encontrava. Nessa época, minha coleção contava com cerca de 250 títulos.</p>
                        </li>
                        <li class="timeline-item bg-white rounded ml-3 p-4 shadow">
                            <div class="timeline-arrow"></div>
                            <h2 class="h5 mb-0">Lançamento do primeiro acervo on-line</h2><span class="small text-gray"><i class="fa fa-clock-o mr-1"></i>entre 1998 e 1999</span>
                            <p class="text-small mt-2 font-weight-light">Lançamento do primeiro acervo on-line, em formato de site/blog, onde já listava os filmes que havia garimpado.</p>
                            
                        </li>
                        <li class="timeline-item bg-white rounded ml-3 p-4 shadow">
                            <div class="timeline-arrow"></div>
                            <h2 class="h5 mb-0">Reformulação das planilhas</h2><span class="small text-gray"><i class="fa fa-clock-o mr-1"></i>ano de 2002</span>
                            <p class="text-small mt-2 font-weight-light">As primeiras listas que eu utilizava para organizar eram planilhas feitas no Excel. Procurando uma forma mais prática para lidar com meu acervo, encontrei o Ant Movie Catalog, que auxiliou imensamente a organização da minha coleção.</p>
                            <p class="text-small mt-2 font-weight-light">Em apenas 13 dias, já havia migrado todas as informações do Excel para o Ant Movie Catalog.</p>
                        </li>
                        <li class="timeline-item bg-white rounded ml-3 p-4 shadow">
                            <div class="timeline-arrow"></div>
                            <h2 class="h5 mb-0">O acervo atingiu a marca de 400 títulos</h2><span class="small text-gray"><i class="fa fa-clock-o mr-1"></i>ano de 2004</span>
                            <p class="text-small mt-2 font-weight-light">Cheguei à marca dos 400 títulos na minha coleção. Na época, quase todas as trocas eram baseadas em fóruns, BBS e blogs.</p>
                        </li>
                        <li class="timeline-item bg-white rounded ml-3 p-4 shadow">
                            <div class="timeline-arrow"></div>
                            <h2 class="h5 mb-0">Primeira atualização do site</h2><span class="small text-gray"><i class="fa fa-clock-o mr-1"></i>ano de 2011</span>
                            <p class="text-small mt-2 font-weight-light">Com o uso do Ant Movie Catalog, era necessário replicar o acervo em uma versão web para facilitar a busca e troca dos títulos. Utilizando banco de dados SQL e funcionalidades avançadas para a época, o novo site foi desenvolvido pelo meu colega Guilherme Nabanete.</p>
                        </li>
                        <li class="timeline-item bg-white rounded ml-3 p-4 shadow">
                            <div class="timeline-arrow"></div>
                            <h2 class="h5 mb-0">Crescimento do site e do acervo</h2><span class="small text-gray"><i class="fa fa-clock-o mr-1"></i>ano de 2013</span>
                            <p class="text-small mt-2 font-weight-light">Com o novo site no ar, houve um "boom" nas trocas. O acervo atingiu a marca de 3.500 títulos.</p>
                        </li>
                        <li class="timeline-item bg-white rounded ml-3 p-4 shadow">
                            <div class="timeline-arrow"></div>
                            <h2 class="h5 mb-0">Segunda atualização do site</h2><span class="small text-gray"><i class="fa fa-clock-o mr-1"></i>ano de 2014</span>
                            <p class="text-small mt-2 font-weight-light">Depois de 3 anos da última atualização, o site passa por uma atualização, ganhando um novo visual (layout) e novas funcionalidades.</p>
                        </li>
                        <li class="timeline-item bg-white rounded ml-3 p-4 shadow">
                            <div class="timeline-arrow"></div>
                            <h2 class="h5 mb-0">Terceira atualização do site</h2><span class="small text-gray"><i class="fa fa-clock-o mr-1"></i>ano de 2015</span>
                            <p class="text-small mt-2 font-weight-light">Mais atualizações importantes foram implantadas no site em 2015, garantindo uma maior facilidade no processo de trocas. Houve também uma pequena atualização visual no layout.</p>
                        </li>
                        <li class="timeline-item bg-white rounded ml-3 p-4 shadow">
                            <div class="timeline-arrow"></div>
                            <h2 class="h5 mb-0">Em pleno crescimento</h2><span class="small text-gray"><i class="fa fa-clock-o mr-1"></i>ano de 2018</span>
                            <p class="text-small mt-2 font-weight-light">Mais de 20 anos se passaram, e o Sessão da Tarde se consolidou como o maior portal de trocas 100% focado em dublagem e filmes e seriados antigos, superando a marca de mais de 8 mil dublagens cadastradas.</p>
                        </li>
                        <li class="timeline-item bg-white rounded ml-3 p-4 shadow">
                            <div class="timeline-arrow"></div>
                            <h2 class="h5 mb-0">Quarta atualização do site</h2><span class="small text-gray"><i class="fa fa-clock-o mr-1"></i>atualmente</span>
                            <p class="text-small mt-2 font-weight-light">Acompanhando o pleno crescimento do site, mais uma vez o parceiro de desenvolvimento Guilherme Nabanete entra em ação para desenvolver um site totalmente moderno, rápido, com foco maior na facilidade das trocas.</p>
                        </li>
                    </ul><!-- End -->
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
    </div>
</template>

<script>
export default {
  name: "about",
  components: {}
};
</script>

<style scoped>
/* Timeline holder */
ul.timeline {
    list-style-type: none;
    position: relative;
    padding-left: 1.5rem;
}

 /* Timeline vertical line */
ul.timeline:before {
    content: ' ';
    background: #fff;
    display: inline-block;
    position: absolute;
    left: 16px;
    width: 4px;
    height: 100%;
    z-index: 400;
    border-radius: 1rem;
}

li.timeline-item {
    margin: 20px 0;
}

/* Timeline item arrow */
.timeline-arrow {
    border-top: 0.5rem solid transparent;
    border-right: 0.5rem solid #fff;
    border-bottom: 0.5rem solid transparent;
    display: block;
    position: absolute;
    left: 2rem;
}

/* Timeline item circle marker */
li.timeline-item::before {
    content: ' ';
    background: #ddd;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    border: 3px solid #fff;
    left: 11px;
    width: 14px;
    height: 14px;
    z-index: 400;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}
</style>
